import { FC, HTMLAttributes, useEffect, useRef } from 'react';
import classNames from 'classnames';
import st from './Input.module.scss';

interface InputProps extends HTMLAttributes<
	HTMLInputElement | HTMLTextAreaElement
> {
	className?: string;
	type?: 'number' | 'text' | 'textarea' | 'custom';
	placeholder?: string;
	value: string;
	readOnly?: boolean;
	onChangeValue?: (value: string) => void;
}

const Input: FC<InputProps> = ({
	type = 'text',
	placeholder,
	readOnly = false,
	value,
	onChangeValue,
	className,
	...otherProps
}) => {
	const textareaRef = useRef<HTMLTextAreaElement | null>(null);

	useEffect(() => {
		if (textareaRef && textareaRef.current) {
			textareaRef.current.style.height = '0px';
			const scrollHeight = textareaRef.current.scrollHeight + 14;
			textareaRef.current.style.height = scrollHeight + 'px';
		}
	}, [value]);

	const onChangeHandler = (
		e:
			| React.ChangeEvent<HTMLInputElement>
			| React.ChangeEvent<HTMLTextAreaElement>,
	) => {
		if (onChangeValue && !readOnly) {
			onChangeValue(e.target.value);
		}
	};

	if (type === 'textarea') {
		return (
			<textarea
				ref={textareaRef}
				{...otherProps}
				placeholder={placeholder}
				value={value}
				readOnly={readOnly}
				maxLength={1500}
				onChange={onChangeHandler}
				className={classNames(st.input, className, {
					[st.readOnly]: readOnly,
				})}
			/>
		);
	}
	return (
		<input
			{...otherProps}
			type={type}
			readOnly={readOnly}
			value={value}
			placeholder={placeholder}
			onChange={onChangeHandler}
			className={classNames(st.input, className, {
				[st.readOnly]: readOnly,
			})}
		/>
	);
};

export default Input;
